module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__errorRed--dark-9c78220904c23d43c2a1fb1e57c9c36e.png";